import React, { FC } from 'react'

import CashInOutModal from './CashInOutModal'

import addContainer from './addContainers'
import editContainers from './editContainers'

export const DecoratedCashInOutAddModal = addContainer(CashInOutModal)
const DecoratedCashInOutEditModal = editContainers(CashInOutModal)

export const OrderCashInAddForm: FC<{ name: string }> = ({ name }) => (
  <DecoratedCashInOutAddModal OperTypeID={3} name={name} title="OrderCashInAdd" />
)

export const OrderCashOutAddForm = ({ name }) => <DecoratedCashInOutAddModal OperTypeID={4} name={name} cashOut />

export const OrderCashInEdit = ({ onOrderAddEdit, name, onAuthorize }) => (
  <DecoratedCashInOutEditModal OperTypeID={3} name={name} onOrderAddEdit={onOrderAddEdit} onAuthorize={onAuthorize} />
)

export const OrderCashOutEdit = ({ onOrderAddEdit, name, onAuthorize }) => (
  <DecoratedCashInOutEditModal
    OperTypeID={4}
    cashOut
    name={name}
    onOrderAddEdit={onOrderAddEdit}
    onAuthorize={onAuthorize}
  />
)

export const OrderCashInCopy = ({ onOrderAddEdit, name }) => (
  <DecoratedCashInOutEditModal OperTypeID={3} copyOrder name={name} onOrderAddEdit={onOrderAddEdit} />
)

export const OrderCashOutCopy = ({ onOrderAddEdit, name }) => (
  <DecoratedCashInOutEditModal OperTypeID={4} copyOrder cashOut name={name} onOrderAddEdit={onOrderAddEdit} />
)
